// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noShrink__3Jr9P {\n  flex-shrink: 0;\n}\n", ""]);
// Exports
exports.locals = {
	"noShrink": "noShrink__3Jr9P"
};
module.exports = exports;
